import { OverviewContainer, OverviewHighlightText } from "../../CommonComponents/CommonViews";
export const ProjectRunbooksSettingsHelp = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>Runbook settings allow you to edit details about the runbook, such as the name and description, as well as see options to clone/delete in the overflow menu.</p>
        </OverviewHighlightText>
    </OverviewContainer>);
